import { toast } from 'react-toastify';

import Button from '../../button/Button';
import { login } from '../../../../services/auth/authService';

const LoginForm = ({ reDirec, btnLoading, changeBtnLoading }) => {
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Read values from the actual DOM so browser/password-manager autofill
        // cannot get out of sync with React form state.
        const formData = new FormData(event.currentTarget);
        const values = {
            email: String(formData.get('email') || '').trim(),
            password: String(formData.get('password') || ''),
        };

        if (!values.email || !values.password) {
            toast.error('Email and password are required.');
            return;
        }

        try {
            changeBtnLoading(true);

            const res = await login(values);

            if (res?.data?.status === 'success') {
                await reDirec();
                toast.success('Login successful');
            } else {
                toast.error(res?.data?.msg || 'Login failed. Please try again.');
            }
        } catch (err) {
            toast.error(err?.response?.data?.msg || err?.message || 'Network error. Please try again.');
        } finally {
            changeBtnLoading(false);
        }
    };

    const inputClassName = 'rounded-lg p-3 bg-white-100 border outline-none w-full text-slate-700 text-[0.9rem] font-medium focus:border-sky-500 border-gray-200';

    return (
        <form onSubmit={handleSubmit} noValidate>
            <div className="flex flex-col justify-center mb-[16px] w-full">
                <label htmlFor="login-email" className="flex justify-start items-center h-full text-gray-800 font-semibold text-[0.9rem] mx-[5px]">
                    Email
                </label>
                <input
                    id="login-email"
                    name="email"
                    type="email"
                    placeholder="Enter your Email"
                    autoComplete="username"
                    className={inputClassName}
                    required
                />
            </div>

            <div className="flex flex-col justify-center mb-[16px] w-full">
                <label htmlFor="login-password" className="flex justify-start items-center h-full text-gray-800 font-semibold text-[0.9rem] mx-[5px]">
                    Password
                </label>
                <input
                    id="login-password"
                    name="password"
                    type="password"
                    placeholder="Enter your Password"
                    autoComplete="current-password"
                    className={inputClassName}
                    minLength={2}
                    maxLength={50}
                    required
                />
            </div>

            <div className="flex flex-wrap flex-col items-end mb-[16px]">
                <Button loading={btnLoading} classes="p-2 bg-primary-100 w-full border border-primary-100 hover:bg-transparent hover:text-primary-100 text-gray-700 font-semibold">
                    Login
                </Button>
            </div>
        </form>
    );
};

export default LoginForm;
